module.exports = __webpack_public_path__ + "img/thumbnail-2@2x.c87c14f8.jpg";